// extracted by mini-css-extract-plugin
export default {"desktop":"UBgNX","compact":"Q5B+4","mobile":"vZLD8"};